module.exports = __webpack_public_path__ + "static/media/12UNCTAD20.3100eb09.jpg";